/**
 * Review Mode feature switch (installation-wide, Super Admin > System
 * Configuration). Mirrors the `review_mode_enabled` flag the backend
 * sends in the login and /me payloads.
 *
 * Read synchronously from the cached `user` object (like portalAccess)
 * so route guards, the admin sidebar and notice-page buttons can decide
 * on first render without a context round-trip. `setReviewModeEnabled`
 * patches the cache and broadcasts a window event so already-mounted
 * chrome (the admin sidebar) re-renders the moment Super Admin saves
 * the toggle. The backend gates every review-mode route regardless, so
 * this only controls visibility.
 */
export const REVIEW_MODE_EVENT = "review-mode-changed";

export const isReviewModeEnabled = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return Boolean(user?.review_mode_enabled);
  } catch {
    return false;
  }
};

export const setReviewModeEnabled = (enabled) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user && typeof user === "object") {
      user.review_mode_enabled = Boolean(enabled);
      localStorage.setItem("user", JSON.stringify(user));
    }
  } catch {
    // Cache write failures are non-fatal: the next login re-syncs.
  }
  try {
    window.dispatchEvent(new CustomEvent(REVIEW_MODE_EVENT));
  } catch {
    // Non-browser environment (tests): nothing to notify.
  }
};
